module.exports = "\n.app-scrollable-content{\n    position: absolute;\n    top:78px;\n    bottom: 0;\n    overflow: auto;\n    width: 100%;\n    -webkit-transition: 0.2s;\n    transition: 0.2s;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./public/app/app.component.css
// module id = ./public/app/app.component.css
// module chunks = main